import React from 'react'
import styled from 'styled-components'

import { QA } from '@hozana/tests/constants'

import { Div, TDivProps } from 'elements/layout/Div'
import { P } from 'elements/text/P'
import type { TPProps } from 'elements/text/P'

const StyledP = styled(P)<TPProps>`
  white-space: pre-line;
  &::first-letter {
    font-size: 2em;
    line-height: 0.75em;
  }
`

export type TCommunityPrayerProps = {
  title: string
  content: string
} & TDivProps

export const CommunityPrayer: TFCC<TCommunityPrayerProps> = ({ title, content, ...otherProps }) => (
  <Div {...otherProps} data-testid={QA.PUBLICATION_PAGE.PRAYER}>
    <P color="black70" fontSize="17px" align="center" m="0 0 20px">
      {title}
    </P>
    <StyledP color="black70" fontSize="17px" align="center">
      {content}
    </StyledP>
  </Div>
)
